import fetchServer from "../fetchServer";

/**
 * GET /main/v1/account/:id/business-change-requests
 * Optional status filter (e.g. Pending).
 */
export default async function getBusinessChangeRequests(
  accountId,
  { status } = {},
) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching business change requests",
    data: [],
  };

  if (!accountId) {
    result.msg = "Missing account id";
    return result;
  }

  try {
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    const qs = params.toString();
    const res = await fetchServer({
      method: "GET",
      url: `/main/v1/account/${encodeURIComponent(
        accountId,
      )}/business-change-requests${qs ? `?${qs}` : ""}`,
    });

    if (res?.data && !res?.data?.error) {
      const payload = res.data?.data;
      const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload?.requests)
            ? payload.requests
            : Array.isArray(res.data)
              ? res.data
              : [];
      result = {
        return: 1,
        msg: res.data?.message || "Successful",
        data: items,
      };
    } else {
      result.msg =
        res?.data?.error || res?.data?.message || res?.error || result.msg;
    }
  } catch (err) {
    console.log("Network Error!", err);
  }

  return result;
}
